/**
 * getPageType
 * Gets the route/page action type.
 */
import * as R from 'ramda';

const getPageType = R.path(['location', 'type']);

export default getPageType;
